import React, { Component } from "react";
import {
  Menu,
  MenuItem,
  DialogActions,
  Fab,
  DialogContent,
  Dialog,
  Button,
  TextField,
  ButtonGroup,
  DialogTitle,
} from "@mui/material";

import { DeleteForever, Remove, Add } from "@mui/icons-material";

import {
  DeliveraMenuEntityInterface,
  DeliveraModifierGroupInterface,
} from "../../../controller/model/delivera/interface";
import PopinaRestaurant from "../../../controller/model/popina/PopinaRestaurant";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";
import swal from "sweetalert";
import { DeliveraItemInterface } from "../../../controller/model/delivera/DeliveraItem";
import Environment from "../../../utils/Environement";

interface StateInterface {
  isOpen: boolean;
  groupeOption: DeliveraModifierGroupInterface | undefined;
  item: DeliveraItemInterface | undefined;
  itemOptionElement: any | null;
  count_max: number;
  count_min: number;
  name: string;
  modifier_ids: DeliveraMenuEntityInterface[];
}

interface PropsInterface {
  restaurant: PopinaRestaurant;
  store: DeliveraStore;
  onClickSave: (groupeOption: DeliveraModifierGroupInterface) => void;
  onClickCreate: (groupeOption: DeliveraModifierGroupInterface) => void;
  onClickDelete: (
    groupeOption: DeliveraModifierGroupInterface,
    item: DeliveraItemInterface
  ) => void;
}

export default class GroupeOptionDetailModalComponent extends Component {
  public props: PropsInterface;
  public state: StateInterface;

  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false,
      groupeOption: undefined,
      item: undefined,
      itemOptionElement: null,
      count_max: 0,
      count_min: 0,
      name: "",
      modifier_ids: [],
    };
    this.props = props;
    this._initBindings();
  }

  _initBindings() {
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.openOptionModal = this.openOptionModal.bind(this);
    this._handleTapSaveButton = this._handleTapSaveButton.bind(this);
    this._handleTapOpenMenuItem = this._handleTapOpenMenuItem.bind(this);
    this._handleCloseMenuItem = this._handleCloseMenuItem.bind(this);
    this._handleTapDeleteOption = this._handleTapDeleteOption.bind(this);
    this.confirmAlert = this.confirmAlert.bind(this);
    this.confirmAlertGroupe = this.confirmAlertGroupe.bind(this);
  }

  openOptionModal(
    groupeOption: DeliveraModifierGroupInterface | undefined,
    item: DeliveraItemInterface | undefined
  ) {
    this.setState({
      isOpen: true,
      groupeOption: groupeOption,
      count_max: groupeOption?.quantity_info?.quantity.max_permitted ?? 1,
      count_min: groupeOption?.quantity_info?.quantity.min_permitted ?? 0,
      name: DeliveraStore.retreiveNameFromTranslation(groupeOption?.title),
      item: item,
      modifier_ids: groupeOption?.modifier_options ?? [],
    });
  }

  handleCloseModal() {
    this.setState({ isOpen: false });
  }

  private _handleTapSaveButton() {
    this.props.onClickSave(this.createGroupeModifier());
  }

  private _handleTapOpenMenuItem(event: any) {
    this.setState({ itemOptionElement: event.currentTarget });
  }

  private _handleCloseMenuItem(item: DeliveraItemInterface | undefined) {
    const modifier_group_ids = item?.modifier_group_ids?.ids.map((e) => e)
    let redondance = false;
    if (undefined !== item) {       
      modifier_group_ids?.forEach(itemModGroup => {
        if(item?.modifier_group_ids?.ids.includes(itemModGroup)) {
          redondance = true;
        }
      });

      if (redondance) {
        swal({
          title: "Attention",
          text: "Cet article détient déjà un groupe d'option",
          icon: "warning",
          dangerMode: true
        });
        return;
      }


      let allOptions = Array.from(this.state.modifier_ids);
      allOptions.push({
        id: item.id,
        type: "ITEM",
      });
      this.setState({ modifier_ids: allOptions });
    }
    this.setState({
      itemOptionElement: null,
    });
  }

  private _handleTapDeleteOption(option: DeliveraItemInterface) {
    let options = Array.from(this.state.modifier_ids);
    const index = options.findIndex((o) => o.id === option.id);
    if (index === -1) {
      console.warn("index of option not found");
      return;
    }
    options.splice(index, 1);
    this.setState({
      modifier_ids: options,
    });
  }

  confirmAlert(option: any) {
    swal({
      title: "Êtes vous vraiment sûr de vouloir supprimer cette option ?",
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then((willDelete: boolean) => {
      if (willDelete) {
        this._handleTapDeleteOption(option);
      }
    });
  }

  private confirmAlertGroupe(_e: any) {
    swal({
      title: `Êtes vous vraiment sûr de vouloir supprimer ce groupe d'option du produit ${DeliveraStore.retreiveNameFromTranslation(
        this.state.item?.title
      )}?`,
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.onClickDelete(this.state.groupeOption!, this.state.item!);
      }
    });
  }

  render() {
    return (
      <div style={{ overflow: "scroll" }}>
        <Dialog
          open={this.state.isOpen}
          onClose={this.handleCloseModal}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle style={{ backgroundColor: "#474F5E", color: "white" }}>
            Groupe d'options
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
                margin: "15px",
                padding: "30px",
              }}
            >
              {/* <h2 style={{ padding: "10px" }}>
                {DeliveraStore.retreiveNameFromTranslation(
                  this.state.groupeOption?.title
                )}
              </h2> */}
              <span
                style={{
                  color: "#474F5E",
                  fontWeight: "bold",
                  fontSize: "22px",
                }}
              >
                Nom du groupe d'options
              </span>
              <TextField
                variant="outlined"
                style={{
                  border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
                  margin: "20px 0",
                  fontSize: "19px",
                  borderRadius: "3px",
                }}
                fullWidth={true}
                value={this.state.name}
                onChange={(event) => {
                  this.setState({ name: event.target.value });
                }}
              />

              <span
                style={{
                  color: "#474F5E",
                  fontWeight: "bold",
                  fontSize: "22px",
                }}
              >
                Ingrédients disponible
              </span>
              <hr />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                }}
              >
                {this.props.store
                  .getOptionsOnGroupeOptionIds(this.state.modifier_ids)
                  .map((aOption, index) => {
                    return (
                      <div key={index}>
                        <Fab
                          key={`${aOption}`}
                          variant="extended"
                          size="medium"
                          aria-label="delete"
                          style={{
                            margin: "10px",
                            backgroundColor: "white",
                            color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
                          }}
                          onClick={() => this.confirmAlert(aOption)}
                        >
                          <div style={{ display: "flex", margin: "auto" }}>
                            {DeliveraStore.retreiveNameFromTranslation(
                              aOption.title
                            )}
                            <DeleteForever style={{ marginLeft: "10px" }} />
                          </div>
                        </Fab>
                      </div>
                    );
                  })}
                <Fab
                  variant="extended"
                  size="medium"
                  aria-label="add"
                  style={{
                    marginTop: "10px",
                    color: "white",
                    backgroundColor: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
                  }}
                  onClick={this._handleTapOpenMenuItem}
                >
                  <Add />
                </Fab>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.itemOptionElement}
                  keepMounted
                  open={Boolean(this.state.itemOptionElement)}
                  onClose={() => this._handleCloseMenuItem(undefined)}
                >
                  {this.props.store.items.map((aItem, index) => {
                    return (
                      <MenuItem
                        key={index}
                        onClick={() => this._handleCloseMenuItem(aItem)}
                      >
                        {DeliveraStore.retreiveNameFromTranslation(aItem.title)}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
              <br />

              <section
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  margin: "20px",
                }}
              >
                <div style={{ width: "30%", textAlign: "center" }}>
                  <p style={{ color: "#474F5E" }}>Quantité maximum</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#474F5E",
                        color: "white",
                        borderRadius: "20px",
                        padding: "21px 30px",
                        fontSize: "25px",
                      }}
                    >
                      {this.state.count_max}
                    </span>
                    <ButtonGroup orientation="vertical" color="secondary">
                      <Button
                        aria-label="reduce"
                        onClick={() =>
                          this.setState({ count_max: this.state.count_max - 1 })
                        }
                      >
                        <Remove fontSize="small" />
                      </Button>
                      <Button
                        aria-label="increase"
                        onClick={() =>
                          this.setState({ count_max: this.state.count_max + 1 })
                        }
                      >
                        <Add fontSize="small" />
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
                <div style={{ width: "30%", textAlign: "center" }}>
                  <p style={{ color: "#474F5E" }}> Quantité minimum</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#474F5E",
                        color: "white",
                        borderRadius: "20px",
                        padding: "21px 30px",
                        fontSize: "25px",
                      }}
                    >
                      {this.state.count_min}
                    </span>
                    <ButtonGroup orientation="vertical" color="secondary">
                      <Button
                        aria-label="reduce"
                        onClick={() =>
                          this.setState({ count_min: this.state.count_min - 1 })
                        }
                      >
                        <Remove fontSize="small" />
                      </Button>
                      <Button
                        aria-label="increase"
                        onClick={() =>
                          this.setState({ count_min: this.state.count_min + 1 })
                        }
                      >
                        <Add fontSize="small" />
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </section>
            </div>
          </DialogContent>

          <DialogActions style={{ marginRight: "20px", marginBottom: "10px" }}>
            {this.state.groupeOption !== undefined &&
              this.state.item !== undefined ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#F1F1F5", color: "white" }}
                  onClick={this.confirmAlertGroupe}
                >
                  Supprimer
                </Button>
              ) : (
                <div></div>
              )}
            <Button
              style={{ color: "white" }}
              color="primary"
              variant="contained"
              onClick={this.handleCloseModal}
            >
              Annuler
            </Button>
            <Button
              style={{ color: "white" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (this.state.groupeOption === undefined) {
                  this.props.onClickCreate(this.createGroupeModifier());
                } else {
                  this._handleTapSaveButton();
                }
              }}
            >
              Enregistrer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  private createGroupeModifier(): DeliveraModifierGroupInterface {
    let updateGroupe = Object.assign({}, this.state.groupeOption);
    updateGroupe.title = {
      translations: {
        fr: this.state.name,
        en: this.state.name,
      },
    };
    if (updateGroupe.quantity_info) {
      updateGroupe.quantity_info.quantity.min_permitted = this.state.count_min;
      updateGroupe.quantity_info.quantity.max_permitted = this.state.count_max;
    } else {
      updateGroupe.quantity_info = {
        quantity: {
          max_permitted: this.state.count_max,
          min_permitted: this.state.count_min,
        },
      };
    }
    updateGroupe.modifier_options = this.state.modifier_ids;
    return updateGroupe;
  }
}
